const steps = [
  {
    num: '01',
    icon: 'ri-phone-line',
    title: 'お問い合わせ',
    desc: 'LINEまたはお電話でお気軽にご連絡ください。お品物の内容や出張希望日時をお伝えください。',
  },
  {
    num: '02',
    icon: 'ri-calendar-check-line',
    title: '日程調整',
    desc: 'ご都合の良い日時に専門スタッフが伺います。平日・土日祝日も対応しております。',
  },
  {
    num: '03',
    icon: 'ri-home-4-line',
    title: '出張査定',
    desc: 'ご自宅や職場へ伺い、その場で丁寧に査定いたします。出張費・査定費は完全無料です。',
  },
  {
    num: '04',
    icon: 'ri-money-cny-circle-line',
    title: '即日現金払い',
    desc: '査定額にご納得いただけましたら、その場で現金にてお支払いします。売却しないことも可能です。',
  },
];

export default function TenjinFlow() {
  return (
    <section id="flow" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-amber-600 font-medium uppercase mb-3">How It Works</span>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4">出張買取の流れ</h2>
          <div className="w-16 h-0.5 bg-amber-400/50 mx-auto mb-6"></div>
          <p className="text-sm text-gray-500 max-w-lg leading-relaxed">
            福岡市・福岡県全域への出張買取は、たった4ステップで完了します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.num} className="relative">
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px border-t-2 border-dashed border-amber-200 z-0 -translate-x-1/2"></div>
              )}
              <div className="relative z-10 bg-white rounded-2xl p-7 flex flex-col gap-4 h-full">
                <div className="flex items-center gap-3">
                  <span className="text-3xl font-serif font-bold text-amber-200">{step.num}</span>
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-full">
                    <i className={`${step.icon} text-amber-600 text-lg`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-800 mb-2">{step.title}</h3>
                  <p className="text-xs text-gray-500 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { icon: 'ri-shield-check-line', title: '出張費・査定費 完全無料', desc: '費用は一切かかりません。査定後に売却しないことも可能です。' },
            { icon: 'ri-map-pin-2-line', title: '福岡県全域対応', desc: '福岡市内はもちろん、福岡県全域への出張に対応しています。' },
            { icon: 'ri-id-card-line', title: '古物商許可取得済み', desc: '福岡県公安委員会許可（901012610013）を取得した安心の買取店です。' },
          ].map((item) => (
            <div key={item.title} className="bg-amber-50 rounded-xl p-6 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                <i className={`${item.icon} text-amber-700 text-lg`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800 mb-1">{item.title}</p>
                <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
